@if (bonuses) {
  @for (bonus of bonuses; track bonus.orderNumber) {
    <div class="bonus-block">
      <div class="bonus-blockLine">
        <div class="bonus-order">
          Заказ
          @if (bonus.orderNumber) {
            <span>№</span>
          }

          {{ bonus.orderNumber }}

          <div class="order-date">от {{ bonus.orderDate | date: 'dd.MM.YYYY' }}</div>
        </div>
        <div class="bonus-amount">
          <div
            [ngClass]="{
              'bonus-amount_red': bonus.bonusAmountInfo.value < 0,
              'bonus-amount_green': bonus.bonusAmountInfo.value > 0,
            }"
          >
            {{
              bonus.bonusAmountInfo.value >= 0
                ? '+' + bonus.bonusAmountInfo.formattedValue
                : bonus.bonusAmountInfo.formattedValue
            }}
          </div>
        </div>
      </div>
      <div class="bonus-blockLine">
        <div class="bonus-type">{{ bonus.message }}</div>
        <div class="bonus-date">{{ bonus.createdAt | date: 'dd MMMM yyyy' }}</div>
      </div>
    </div>
  }
}
